import { ThirdwebAuthController } from "./auth/thirdweb";

export const authController = new ThirdwebAuthController();
